export default __webpack_public_path__ + "static/media/gn.97a38e72.jpg";